import { appInsight, collectProperties } from 'components/appInsight';
import { ScommesseInEvidenzaCard } from 'components/cards/scommesseInEvidenceCard';
import { Carousel } from 'components/carousel';
import { Wrapper } from 'components/wrapper';
import { AmbienteContext } from 'context/Ambiente';
import { useAvvenimenti, useDynamicTempate, useInfoTipoList } from 'features/sport/hooks';
import { KeyManagerSport } from 'features/sport/utils/keyManager';
import { VisualizationEnum } from 'lib/api/sport/sportScommesseBySlugResponse';
import { useRouter } from 'next/router';
import React, { memo } from 'react';
import { isTruthy } from 'utility/functions';
import styles from './SportInEvidenza.module.scss';

export type SportInEvidenzaProps = {
  title: string;
  className: string;
};

const MySportInEvidenza = memo(function SportInEvidenza({ title }: SportInEvidenzaProps) {
  const { slug, template: keys } = useDynamicTempate<Array<string>>();
  const { infoTipoScommessaList } = useInfoTipoList(
    (keys ?? [])
      .map((key) => new KeyManagerSport(key).tipoScommessaId)
      .filter((key, index, list) => list.indexOf(key) === index)
  );

  const avvenimentoList = useAvvenimenti();
  if (!isTruthy(avvenimentoList.length)) {
    appInsight?.trackTrace({
      message: 'In evidenza con scommesse senza AvvenimentoList',
      properties: collectProperties(false, keys),
    });
    return <React.Fragment key={'Sport-In-Evidenza'} />;
  }

  const filteredKeys: string[] = (keys ?? []).filter((key) => {
    const { tipoScommessaId } = new KeyManagerSport(key);
    const tipoScommessa = (infoTipoScommessaList ?? []).find((tipoScommessa) => tipoScommessa?.key === tipoScommessaId);
    return tipoScommessa?.tipoVisualizzazione === VisualizationEnum.EsitiUnderThree;
  });

  if (!isTruthy(filteredKeys?.length)) {
    appInsight?.trackTrace({
      message: 'In evidenza con scommesse con tipoVisualizzazione != 1',
      properties: collectProperties(false, keys),
    });
    return <React.Fragment key={'Sport-In-Evidenza'} />;
  }

  return (
    <Wrapper
      key={`Sport-In-Evidenza-${slug}-${(avvenimentoList ?? []).length}`}
      noPaddingLeft
      className="backgroundElement"
      noPaddingRight
      bgColorTransparent
    >
      <Carousel
        title={title}
        classNameTitle={styles.paddingLeft}
        cardContainerClassName={styles.inEvidenzaCardContainer}
      >
        {filteredKeys.map((key) => (
          <ScommesseInEvidenzaCard key={`${slug}-${key}`} scommessaInEvidenzaKey={key} />
        ))}
      </Carousel>
    </Wrapper>
  );
});

export const SportInEvidenza = (props: SportInEvidenzaProps) => {
  const { isReady, isFallback, asPath } = useRouter();

  return (
    <AmbienteContext.Provider
      key={`content-next-events`}
      value={{
        ambiente: 'sport',
        pathScommessa: ['sport', 'inEvidenza', 'scommesse'],
      }}
    >
      <MySportInEvidenza key={`MySportInEvidenza-${isReady}-${isFallback}-${asPath}`} {...props} />
    </AmbienteContext.Provider>
  );
};
